/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upgrade_Feat_Unlimited_DescInputs */

const en_upgrade_feat_unlimited_desc = /** @type {(inputs: Upgrade_Feat_Unlimited_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scale without limits. No listing caps.`)
};

const es_upgrade_feat_unlimited_desc = /** @type {(inputs: Upgrade_Feat_Unlimited_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escala sin límites. Sin límite de anuncios.`)
};

const fr_upgrade_feat_unlimited_desc = /** @type {(inputs: Upgrade_Feat_Unlimited_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Évoluez sans limites. Pas de plafond d'annonces.`)
};

const de_upgrade_feat_unlimited_desc = /** @type {(inputs: Upgrade_Feat_Unlimited_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skalieren ohne Grenzen. Keine Inseratsbeschränkungen.`)
};

const id_upgrade_feat_unlimited_desc = /** @type {(inputs: Upgrade_Feat_Unlimited_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skala tanpa batas. Tidak ada batasan listing.`)
};

/** @type {(inputs: Upgrade_Feat_Unlimited_DescInputs) => LocalizedString} */
const ja_upgrade_feat_unlimited_desc = en_upgrade_feat_unlimited_desc;

/** @type {(inputs: Upgrade_Feat_Unlimited_DescInputs) => LocalizedString} */
const zh_upgrade_feat_unlimited_desc = en_upgrade_feat_unlimited_desc;

/** @type {(inputs: Upgrade_Feat_Unlimited_DescInputs) => LocalizedString} */
const ar_upgrade_feat_unlimited_desc = en_upgrade_feat_unlimited_desc;

/** @type {(inputs: Upgrade_Feat_Unlimited_DescInputs) => LocalizedString} */
const it_upgrade_feat_unlimited_desc = en_upgrade_feat_unlimited_desc;

/** @type {(inputs: Upgrade_Feat_Unlimited_DescInputs) => LocalizedString} */
const ru_upgrade_feat_unlimited_desc = en_upgrade_feat_unlimited_desc;

/** @type {(inputs: Upgrade_Feat_Unlimited_DescInputs) => LocalizedString} */
const pt_upgrade_feat_unlimited_desc = en_upgrade_feat_unlimited_desc;

/** @type {(inputs: Upgrade_Feat_Unlimited_DescInputs) => LocalizedString} */
const ko_upgrade_feat_unlimited_desc = en_upgrade_feat_unlimited_desc;

/**
* | output |
* | --- |
* | "Scale without limits. No listing caps." |
*
* @param {Upgrade_Feat_Unlimited_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const upgrade_feat_unlimited_desc = /** @type {((inputs?: Upgrade_Feat_Unlimited_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upgrade_Feat_Unlimited_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_upgrade_feat_unlimited_desc(inputs)
	if (locale === "es") return es_upgrade_feat_unlimited_desc(inputs)
	if (locale === "fr") return fr_upgrade_feat_unlimited_desc(inputs)
	if (locale === "de") return de_upgrade_feat_unlimited_desc(inputs)
	if (locale === "ja") return ja_upgrade_feat_unlimited_desc(inputs)
	if (locale === "zh") return zh_upgrade_feat_unlimited_desc(inputs)
	if (locale === "ar") return ar_upgrade_feat_unlimited_desc(inputs)
	if (locale === "id") return id_upgrade_feat_unlimited_desc(inputs)
	if (locale === "it") return it_upgrade_feat_unlimited_desc(inputs)
	if (locale === "ru") return ru_upgrade_feat_unlimited_desc(inputs)
	if (locale === "pt") return pt_upgrade_feat_unlimited_desc(inputs)
	return ko_upgrade_feat_unlimited_desc(inputs)
});